// src/useDocumentMeta.js
import { useEffect } from 'react';

export default function useDocumentMeta({
  title,
  description,
  canonical,
  ogImage,
  ogType = 'website'
}) {
  useEffect(() => {
    // — Title tag
    if (title) document.title = title;

    // — Meta description
    if (description) {
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = description;
    }

    // — Canonical link
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    // Helper to ensure an OG meta tag exists
    const upsertOG = (prop, content) => {
      let tag = document.querySelector(`meta[property='${prop}']`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', prop);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };

    // — OG tags
    if (title)        upsertOG('og:title',       title);
    if (description)  upsertOG('og:description', description);
    if (canonical)    upsertOG('og:url',         canonical);
    if (ogImage)      upsertOG('og:image',       ogImage);
    if (ogType)       upsertOG('og:type',        ogType);
  }, [title, description, canonical, ogImage, ogType]);
}
